<div class="top">
  <h2>Your outfits</h2>

  <div class="actions">
    <a mat-raised-button routerLinkActive="active" ariaCurrentWhenActive="page" routerLink="/creator"
    color="primary">Add outfits</a>

<!-- TODO
    <mat-form-field>
      <mat-label>Find outfits</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ex: Smart" #input>
    </mat-form-field>
-->
  </div>
</div>

<div class="outfits">
  @for (outfitItem of outfitList; track outfitItem) {
    <app-outfit-card [outfit]="outfitItem" [garments]="prepareGarmentsForOutfitById(outfitItem.id)" ></app-outfit-card>
  }
</div>